module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-tooltip",
    class: {
      'touched': _vm.touch, 'when-shown': _vm.show
    },
    style: (_vm.tooltipStyle)
  }, [_c('div', {
    ref: "ripple",
    staticClass: "mu-tooltip-ripple",
    class: {
      'when-shown': _vm.show
    },
    style: (_vm.rippleStyle)
  }), _vm._v(" "), _c('span', {
    staticClass: "mu-tooltip-label"
  }, [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fbcecd1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/tooltip/tooltip.vue
// module id = 446
// module chunks = 1